module.exports = __webpack_public_path__ + "img/text-size.533d88e3.png";